import { render, staticRenderFns } from "./ModalConfirmarExcluir.vue?vue&type=template&id=63b35f5f&lang=pug"
import script from "./ModalConfirmarExcluir.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarExcluir.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarExcluir.vue?vue&type=style&index=0&id=63b35f5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports